import {Component, ElementRef, OnInit, Renderer2, ViewChild} from '@angular/core';
import {ModalController} from "@ionic/angular";
import {CommonUtils} from "../../utils/common";
import AirDatepicker from "air-datepicker";
import pl from "air-datepicker/locale/pl";

@Component({
  selector: 'app-select-sms-crm-module-expiration-date',
  templateUrl: './select-sms-crm-module-expiration-date.component.html',
  styleUrls: ['./select-sms-crm-module-expiration-date.component.scss'],
})
export class SelectSmsCrmModuleExpirationDateComponent implements OnInit {


  @ViewChild('dateInput') datepickerRef: ElementRef;
  private selectedDate: any;

  constructor(private renderer: Renderer2,
              private modalController: ModalController, private commonUtils: CommonUtils) {
  }

  ngOnInit() {
    setTimeout(() => {
      const datepicker = this.datepickerRef.nativeElement as HTMLDivElement;
      new AirDatepicker(datepicker, {
        range: false,
        locale: pl,
        minDate: new Date(),
        onSelect: ({date, formattedDate, datepicker}) => {
          if (date) {
            let s = this.commonUtils.dateTime2Str(date);
            this.selectedDate = s?.split(' ')[0];
            this.modalController.dismiss(this.selectedDate);

          }
        }
      });
      const childrenIterator = datepicker.children[Symbol.iterator]();

      let child = childrenIterator.next().value;

      while (child) {
        this.renderer.setStyle(child, 'width', '100%');
        child = childrenIterator.next().value;
      }
    }, 0);


  }

}
